'use strict';


export class DSSectionCtrl
{
	$scope;
	$filter;
	$mdDialog;
	jsDataService;
	dsModel;
	
	constructor($scope, $filter, jsDataService, $mdDialog){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.$mdDialog = $mdDialog;
		this.jsDataService = jsDataService;
		this.classif = this.jsDataService.get('cfgClassif', {});
		this.postConstruct();
	}
	
	postConstruct(){
		
	}
}